import { render } from "./ProjectDetailCarousel.vue?vue&type=template&id=10fa9eda&scoped=true"
import script from "./ProjectDetailCarousel.vue?vue&type=script&lang=js"
export * from "./ProjectDetailCarousel.vue?vue&type=script&lang=js"

import "./ProjectDetailCarousel.vue?vue&type=style&index=0&id=10fa9eda&lang=scss&scoped=true"

import exportComponent from "/Users/casey/Documents/Development/visualspace_v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10fa9eda"]])

export default __exports__